import { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const defaultCategory = "Ongoing";

const CategoryContext = createContext<{
  selectedCategory: string;
  setSelectedCategory: (value: string) => void;
}>({
  selectedCategory: defaultCategory,
  setSelectedCategory: () => {},
});

export const CategoryProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedCategory, setSelectedCategory] = useState(defaultCategory);
  const location = useLocation();

  // Reset on hard reload
  useEffect(() => {
    const navEntry = performance.getEntriesByType("navigation")[0];
    const isReload =
      navEntry instanceof PerformanceNavigationTiming && navEntry.type === "reload";

    if (isReload) {
      sessionStorage.removeItem("selectedCategory");
      setSelectedCategory(defaultCategory);
    } else {
      const saved = sessionStorage.getItem("selectedCategory");
      if (saved) setSelectedCategory(saved);
    }
  }, []);

  // Sync sessionStorage on change
  useEffect(() => {
    sessionStorage.setItem("selectedCategory", selectedCategory);
  }, [selectedCategory]);

  // Reset when user navigates away from /projects
  useEffect(() => {
    if (!location.pathname.startsWith("/projects")) {
      setSelectedCategory(defaultCategory);
      sessionStorage.removeItem("selectedCategory");
    }
  }, [location]);

  return (
    <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategory = () => useContext(CategoryContext);
